/**
 * Round distance to one decimal place for display
 * @param {number} distance - The distance value to round
 * @returns {number} - Rounded distance
 */
export const roundDistance = (distance) => {
  if (!distance) return distance;
  return Math.round(distance * 10) / 10;
};

/**
 * Format a date range for display
 * @param {Date} startDate - Start date of the range
 * @param {Date} endDate - End date of the range
 * @returns {string} - Formatted date range (e.g., "Oct 20 - 26" or "Oct 27 - Nov 2")
 */
export const formatDateRange = (startDate, endDate) => {
  const startFormatted = startDate.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric'
  });

  // If same month, just show the end day number
  if (startDate.getMonth() === endDate.getMonth()) {
    return `${startFormatted} - ${endDate.getDate()}`;
  }

  // Different months, show full end date
  const endFormatted = endDate.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric'
  });

  return `${startFormatted} - ${endFormatted}`;
};

/**
 * Format mileage with one decimal place
 * @param {number} mileage - The mileage value
 * @returns {string} - Formatted mileage (e.g., "15.0")
 */
export const formatMileage = (mileage) => {
  return typeof mileage === 'number' ? mileage.toFixed(1) : '0.0';
};

/**
 * Get abbreviated day name
 * @param {Date} date - The date to get the abbreviated day for
 * @returns {string} - Abbreviated day name (e.g., "M", "T", "Th", "Su")
 */
export const getAbbreviatedDay = (date) => {
  const dayIndex = date.getDay();
  const abbreviated = ['Su', 'M', 'T', 'W', 'Th', 'F', 'S'];
  return abbreviated[dayIndex];
};

/**
 * Capitalize the first letter of a string
 * @param {string} str - The string to capitalize
 * @returns {string} - Capitalized string
 */
export const capitalize = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};
